import { jsx as _jsx } from "react/jsx-runtime";
// Components
import { InputDropdown } from '@kubit/web-ui-product-components';
import { InputTooltipComponent } from '../input-basic/components/tooltip/input-tooltip.component';
// Constants
import { DEFAULT_RIGHT_ICON } from './constants/input-dropdown.constants';
const InputDropdownComponent = ({ analytics, styles, tooltip, tooltipTitle, closeIcon, ...props }) => {
    return (_jsx(InputDropdown, { ...props, additionalInfo: _jsx(InputTooltipComponent, { tooltip, closeIcon, title: tooltipTitle }), errorIcon: { icon: props.errorIcon, color: styles?.iconColor }, errorMessage: { content: props.errorMessage }, label: { content: props.label }, rightIcon: { icon: DEFAULT_RIGHT_ICON } }));
};
export { InputDropdownComponent };
//# sourceMappingURL=input-dropdown.component.js.map